<template>
  <div id="resultList" class="resultList">
    <ul class="list-main">
      <li v-for="(item, index) in data " :key="index">
        <div class="list-item" @click="clkxShow(item, index)">
          <div class="list-left">
            <div class="div-tag">
              <div v-if="item.isRecommend" class="list-tag">Best value</div>
              <div v-if="item.isQuickest" class="list-tag">Quickest</div>
              <div v-if="item.isCheapest" class="list-tag">Cheapest</div>
            </div>

            <div><img
              :src="require('@/assets/img/client/check/' + getBusinessType(item) + '.png')"
              style="width: 16px;"
            > {{
              getMode(item) }}</div>
            <div v-if="item.businessType == 1">
              <img src="../../../assets/img/client/chat/address.png" style="width: 16px;">
              {{ item.originZipcode }},{{ item.originName }}
              <span class="p-line" />
              <img src="../../../assets/img/client/chat/car.png" style="width: 16px;">
              <span class="p-line" />
              <img src="../../../assets/img/client/chat/address.png" style="width: 16px;">
              {{ inputData.DestinationZipCode }},{{ inputData.DestinationAddressCode }}
            </div>
            <div v-if="item.businessType == 2">
              <img src="../../../assets/img/client/chat/address.png" style="width: 16px;">
              <span v-if="inputData.OriginType != 1">{{ inputData.OriginZipCode }},{{ inputData.OriginAddressCode
              }}</span>
              <span v-if="inputData.OriginType != 1" class="p-line" />
              <img v-if="inputData.OriginType != 1" src="../../../assets/img/client/chat/car.png" style="width: 16px;">
              <span v-if="inputData.OriginType != 1" class="p-line" />
              {{ item.startPortCode }}
              <span class="p-line" />
              <img src="../../../assets/img/client/check/Air.png" style="width: 16px;">
              <span class="p-line" />
              {{ item.destPortCode }}
              <span v-if="inputData.DestinationType != 1" class="p-line" />
              <img
                v-if="inputData.DestinationType != 1"
                src="../../../assets/img/client/chat/address.png"
                style="width: 16px;"
              >
              <span v-if="inputData.DestinationType != 1">{{ inputData.DestinationZipCode }},{{
                inputData.DestinationAddressCode }}</span>
            </div>
            <div v-if="item.businessType == 3">
              <img src="../../../assets/img/client/chat/address.png" style="width: 16px;">
              {{ inputData.OriginZipCode }},{{ inputData.OriginAddressCode }}
              <span class="p-line" />
              <img src="../../../assets/img/client/check/Ocean.png" style="width: 16px;">
              <span class="p-plus">+</span>
              <img src="../../../assets/img/client/chat/car.png" style="width: 16px;">
              <span class="p-line" />
              <img src="../../../assets/img/client/chat/address.png" style="width: 16px;">
              #{{ inputData.FbaWarehouseCode }}-{{ item.destinationZipcode }},{{ item.destinationName }}
            </div>
            <div v-if="item.businessType == 4">
              <img src="../../../assets/img/client/chat/address.png" style="width: 16px;">
              {{ inputData.OriginZipCode }},{{ inputData.OriginAddressCode }}
              <span class="p-line" />
              <img src="../../../assets/img/client/chat/car.png" style="width: 16px;">
              <span class="p-line" />
              {{ item.startPortCode }}
              <span class="p-line" />
              <img src="../../../assets/img/client/check/Ocean.png" style="width: 16px;">
              <span class="p-line" />
              {{ item.destPortCode }}
              <span class="p-line" />
              <img src="../../../assets/img/client/chat/address.png" style="width: 16px;">
              {{ inputData.DestinationZipCode }},{{ inputData.DestinationAddressCode }}
            </div>
            <button style="cursor: pointer;" @click.stop.prevent="clickChat(item)">Chat now</button>
          </div>
          <div class="list-middle">
            <div>US ${{ item.totalAmount.toFixed(3) }}</div>
            <button @click="toOrder(item)">Select</button>
            <div><span>Rate expires</span></div>
            <div>{{ item.expirationTime }}(UTC)</div>
          </div>
          <div class="list-right">
            <i :class="{ 'el-icon-arrow-down': !item.isTrue, 'el-icon-arrow-up': item.isTrue }" />
          </div>

        </div>
        <div v-if="item.isTrue" class="list-card">
          <!-- 空运/海运 门起运 -->
          <div
            v-if="(item.businessType == 2 || item.businessType == 4) && (item.calculationType == 1 || item.calculationType == 2)"
          >
            <div v-if="item.pickupAmount > 0">
              <div class="card-title">
                <span>{{ `${inputData.OriginZipCode},${inputData.OriginAddressCode}>${item.startPortCode}` }}</span>
              </div>
              <div class="card-table">
                <table>
                  <tr>
                    <td>Fee code</td>
                    <td>Fee name</td>
                    <td>Comment</td>
                    <td>Units</td>
                    <td>Units price</td>
                    <td>Amount</td>
                  </tr>
                  <tr>
                    <td>PICKUP</td>
                    <td>Pickup Fee</td>
                    <td>Pickup Fee</td>
                    <td>{{ item.pickupChargeWeight }}</td>
                    <td>US ${{ (item.pickupAmount/item.pickupChargeWeight).toFixed(3) }}</td>
                    <td>US ${{ item.pickupAmount }}</td>
                  </tr>
                  <tr v-if="item.startLiftgateAmount > 0">
                    <td>LIFT</td>
                    <td>Lift Gate Charge</td>
                    <td>Flat Fee</td>
                    <td>1</td>
                    <td>US ${{ item.startLiftgateAmount }}</td>
                    <td>US ${{ item.startLiftgateAmount }}</td>
                  </tr>
                </table>
              </div>
              <div class="card-subtotal">
                <span>Subtotal: US ${{ pickupFeeSum(item) }}</span>
              </div>
            </div>
            <div v-if="item.originFeeList.length > 0">
              <div class="card-title">
                <span>Origin charges</span>
              </div>
              <div class="card-table">
                <table>
                  <tr>
                    <td>Fee code</td>
                    <td>Fee name</td>
                    <td>Comment</td>
                    <td>Units</td>
                    <td>Units price</td>
                    <td>Amount</td>
                  </tr>
                  <tr v-for="feeItem in item.originFeeList" :key="feeItem">
                    <td>{{ feeItem.code }}</td>
                    <td>{{ feeItem.name }}</td>
                    <td>{{ feeItem.comment }}</td>
                    <td>{{ feeItem.units }}</td>
                    <td>US ${{ feeItem.unitPrice }}</td>
                    <td>US ${{ feeItem.amount }}</td>
                  </tr>
                </table>
              </div>
              <div class="card-subtotal">
                <span>Subtotal: US ${{ originFeeSum(item) }}</span>
              </div>
            </div>
          </div>
          <div>
            <div class="card-title">
              <span v-if="item.businessType == '1'">{{ item.originZipcode }},{{ item.originName }} >
                {{ inputData.DestinationZipCode }},{{ item.destinationName }}</span>
              <span v-if="item.businessType == '2'">{{ item.startPortCode }} >
                {{ item.destPortCode }}</span>
              <span v-if="item.businessType == '3'">{{ inputData.OriginZipCode }},{{ inputData.OriginAddressCode }}
                > #{{ inputData.FbaWarehouseCode }} -
                {{ item.destinationName }},{{ item.destinationProvinceName }},{{ item.destinationZipcode }}</span>

              <span v-if="item.businessType == '4'">{{ item.startPortCode }} >
                {{ item.destPortCode }}</span>
            </div>
            <div class="card-table">
              <table>
                <tr>
                  <td>Fee code</td>
                  <td>Fee name</td>
                  <td>Comment</td>
                  <td>Units</td>
                  <td>Units price</td>
                  <td>Amount</td>
                </tr>
                <tr v-for="feeItem in item.feeList" :key="feeItem">
                  <td>{{ feeItem.code }}</td>
                  <td>{{ feeItem.name }}</td>
                  <td>{{ feeItem.comment }}</td>
                  <td>{{ feeItem.units }}</td>
                  <td>US ${{ feeItem.unitPrice }}</td>
                  <td>US ${{ feeItem.amount }}</td>
                </tr>
                <tr v-if="item.startLiftgateAmount > 0 && item.businessType != 2 && item.businessType != 4">
                  <td>LIFT</td>
                  <td>Lift Gate Charge</td>
                  <td>Flat Fee</td>
                  <td>1</td>
                  <td>US ${{ item.startLiftgateAmount }}</td>
                  <td>US ${{ item.startLiftgateAmount }}</td>
                </tr>
                <tr v-if="item.pickupAmount > 0 && item.businessType != 2 && item.businessType != 4">
                  <td>PICKUP</td>
                  <td>Pickup Charges</td>
                  <td>-</td>
                  <td>{{ item.pickupChargeWeight }}</td>
                  <td>US ${{ (item.pickupAmount/item.pickupChargeWeight).toFixed(3) }}</td>
                  <td>US ${{ item.pickupAmount }}</td>
                </tr>
              </table>
            </div>
            <div class="card-subtotal">
              <span>Subtotal: US ${{ getSubTotal(item) }}</span>
            </div>
          </div>
          <!-- 空运/海运 到门/到港 -->
          <div
            v-if="(item.businessType == 2 || item.businessType == 4) && (item.calculationType == 1 || item.calculationType == 2 || item.calculationType == 3 || item.calculationType == 4)"
          >
            <div v-if="filteredDestFeeList(item).length > 0">
              <div class="card-title">
                <span>Destination charges</span>
              </div>
              <div class="card-table">
                <table>
                  <tr>
                    <td>Fee code</td>
                    <td>Fee name</td>
                    <td>Comment</td>
                    <td>Units</td>
                    <td>Units price</td>
                    <td>Amount</td>
                  </tr>
                  <tr v-for="(destFeeItem, destFeeIndex) in filteredDestFeeList(item)" :key="destFeeIndex">
                    <td>{{ destFeeItem.code }}</td>
                    <td>{{ destFeeItem.name }}</td>
                    <td>{{ destFeeItem.comment }}</td>
                    <td>{{ destFeeItem.units }}</td>
                    <td>US ${{ destFeeItem.unitPrice }}</td>
                    <td>US ${{ destFeeItem.amount }}</td>
                  </tr>
                </table>
              </div>
              <div class="card-subtotal">
                <span>Subtotal: US ${{ destFeeSum(item) }}</span>
              </div>
            </div>
            <!-- 到门 -->
            <div v-if="(item.calculationType == 1 || item.calculationType == 4)">
              <div class="card-title">
                <span>{{ `${item.destPortCode}>${inputData.DestinationZipCode},${inputData.DestinationAddressCode}`
                }}</span>
              </div>
              <div class="card-table">
                <table>
                  <tr>
                    <td>Fee code</td>
                    <td>Fee name</td>
                    <td>Comment</td>
                    <td>Units</td>
                    <td>Units price</td>
                    <td>Amount</td>
                  </tr>
                  <tr v-for="(destFeeItem, destFeeIndex) in usedDestFeeList(item)" :key="destFeeIndex">
                    <td>{{ destFeeItem.code }}</td>
                    <td>{{ destFeeItem.name }}</td>
                    <td>{{ destFeeItem.comment }}</td>
                    <td>{{ destFeeItem.units }}</td>
                    <td>US ${{ destFeeItem.unitPrice }}</td>
                    <td>US ${{ destFeeItem.amount }}</td>
                  </tr>
                  <tr v-if="item.destLiftgateAmount > 0">
                    <td>LIFT</td>
                    <td>Lift Gate Charge</td>
                    <td>Flat Fee</td>
                    <td>1</td>
                    <td>US ${{ item.destLiftgateAmount }}</td>
                    <td>US ${{ item.destLiftgateAmount }}</td>
                  </tr>
                </table>
              </div>
              <div class="card-subtotal">
                <span>Subtotal: US ${{ destFeeUesdSum(item) }}</span>
              </div>
            </div>
          </div>
          <div v-if="inputData.IsCustomsBrokerage && customsFeeSum(item) > 0">
            <div class="card-title">
              <span>Customs Brokerage</span>
            </div>
            <div class="card-table">
              <table>
                <tr>
                  <td>Fee code</td>
                  <td>Comment</td>
                  <td>Amount</td>
                </tr>
                <tr v-for="( item, index ) in item.customsFeeList " :key="index">
                  <td>{{ item.nameEn }}
                  </td>
                  <td>{{ item.commentEn }}</td>
                  <td>US ${{ item.amount }}</td>
                </tr>
                <tr v-if="item.bondAmount > 0">
                  <td>{{ inputData.BondType === 1 ? 'Single Entry Bond(based on goods value of USD' + inputData.GoodsValue +
                    ')' : 'Annual bond' }}
                  </td>
                  <td>-</td>
                  <td>US ${{ item.bondAmount }}</td>
                </tr>
                <tr v-if="item.ISFBondAmount > 0">
                  <td>ISF Bond</td>
                  <td>-</td>
                  <td>US ${{ item.ISFBondAmount }}</td>
                </tr>
              </table>
            </div>
            <div class="card-subtotal">
              <span>Subtotal: US ${{ customsFeeSum(item) }}</span>
            </div>
          </div>
          <div v-if="item.insuranceAmount > 0">
            <div class="card-title">
              <span>Insurance</span>
            </div>
            <div class="card-table">
              <table>
                <tr>
                  <td>Fee code</td>
                  <td>Comment</td>
                  <td>Amount</td>
                </tr>
                <tr>
                  <td>Insurance (based on goods value of USD {{ inputData.GoodsValue }})
                  </td>
                  <td>-</td>
                  <td>US ${{ item.insuranceAmount }}</td>
                </tr>
              </table>
            </div>
            <div class="card-subtotal">
              <span>Subtotal: US ${{ item.insuranceAmount }}</span>
            </div>
          </div>
          <div class="card-total">
            <span>Total: US ${{ item.totalAmount }}</span>
          </div>
          <div v-if="item.detailList.length > 0" class="card-remarks">
            <p v-for="( detail, index ) in item.detailList " :key="index">{{ detail.moduleNameEn }}:
              <span>{{ detail.contentEn }}</span>
            </p>

          </div>
        </div>
      </li>
    </ul>
    <ChatDialog v-if="chatVisible" ref="ChatDialog" @close="closeChat" />
  </div>
</template>

<script>
import {
  CreateFBAOrder,
  CreateAirOrder,
  CreateExpOrder,
  CreateSeaOrder
} from '../../../api/order.js'
import {
  GetChatUserId
} from '@/api/user.js'
import ChatDialog from '@/client/home/chatBox/index.vue'
export default {
  name: 'ResultList',
  components: {
    // 组件的引用
    ChatDialog
  },
  props: {
    // 父辈向子辈传参
    sortTitle: ''
  },
  data() {
    return {
      data: undefined,
      inputData: undefined,
      chatVisible: false
    }
  },
  computed: {},
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    closeChat() {
      this.chatVisible = false
    },
    clickChat(item) {
      GetChatUserId().then(res => {
        if (res.code === 200) {
          this.chatVisible = true
          this.$nextTick(() => {
            this.$refs.ChatDialog.init(this.inputData, item, res.data)
          })
        }
      })
    },
    init(data, inputData) {
      console.log(JSON.stringify(inputData))
      this.data = data
      this.inputData = inputData
    },
    getSubTotal(item) {
      var total = 0
      if (item.feeList) {
        item.feeList.forEach(item => {
          total += item.amount
        })
      }
      if (item.startLiftgateAmount > 0 && item.businessType != 2 && item.businessType != 4) {
        total += item.startLiftgateAmount
      }
      if (item.pickupAmount > 0 && item.businessType != 2 && item.businessType != 4) {
        total += item.pickupAmount
      }
      return total.toFixed(2)
    },
    getBusinessType(item) {
      switch (item.businessType) {
        case 1:
          return `Express`
        case 2:
          return `Air`
        case 3:
          return `Ocean`
        case 4:
          return `Ocean`
      }
    },
    getMode(item) {
      switch (item.businessType) {
        case 1:
          return `Express | Est.${item.workDays} days `
        case 2:
          return `Air | Est.${item.workDays} days | (${this.GetType(item)})`
        case 3:
          return `Ocean | Est.${item.workDays} days`
        case 4:
          return `Ocean | Est.${item.workDays} days | (${this.GetType(item)})`
      }
    },
    GetType(item) {
      switch (item.businessType) {
        case 2:
          switch (item.calculationType) {
            case 1:
              return `door to door`
            case 2:
              return `door to airport`
            case 3:
              return `airport to airport`
            case 4:
              return `airport to door`
          }
          break
        case 4:
          switch (item.calculationType) {
            case 1:
              return `door to door`
            case 2:
              return `door to port`
            case 3:
              return `port to port`
            case 4:
              return `port to door`
          }
          break
      }
    },
    getAddress(item) {
      switch (item.businessType) {
        case 1:
          return `${item.originZipcode},${item.originName} - ${this.inputData.DestinationZipCode},${this.inputData.DestinationAddressCode}`
        case 2:
          return `${this.inputData.OriginZipCode},${this.inputData.OriginAddressCode} - ${item.startPortCode} - ${item.destPortCode} - ${this.inputData.DestinationZipCode},${this.inputData.DestinationAddressCode}`
        case 3:
          return `${this.inputData.OriginZipCode},${this.inputData.OriginAddressCode} —— #${this.inputData.FbaWarehouseCode} - ${item.destinationZipcode},${item.destinationName}`
      }
    },
    changeType(item) {
      switch (item.businessType) {
        case 1:
          return `Express`
        case 2:
          return `Air`
        case 3:
          return `Ocean`
        case 4:
          return `Ocean`
      }
    },
    // 方法
    // 点击标题展开内容
    clkxShow(item, index) {
      this.data.forEach((res, i) => {
        if (index === i) {
          this.$set(res, 'isTrue', !item.isTrue)
        }
      })
    },
    toOrder(item) {
      switch (item.businessType) {
        case 1: // 快递
          this.createExpOrder(item)
          break
        case 2: // 空运
          this.createAirOrder(item)
          break
        case 3: // fab
          this.createFbaOrder(item)
          break
        case 4: // 海运
          this.createSeaOrder(item)
          break
      }
    },
    createFbaOrder(item) {
      var param = {
        isDraft: true,
        startCityId: this.inputData.OriginCityId,
        destCountryId: this.inputData.DestinationCountryId,
        storeCode: this.inputData.FbaWarehouseCode,
        quantity: this.inputData.TotalQuantity,
        weight: this.inputData.TotalWeight,
        volume: this.inputData.TotalVolume,
        channelId: item.channelId,
        totalValue: this.inputData.GoodsValue,
        buyInsurance: this.inputData.IsInsurance ? 1 : 0,
        productName: this.inputData.GoodsName,
        goodsReadyType: this.inputData.GoodsReadyType,
        goodsReadyTime: this.inputData.GoodsReadyTime,
        isKnowerShipper: this.inputData.IsKnown ? 1 : 0,
        isCustomsBrokerage: this.inputData.IsCustomsBrokerage ? 1 : 0,
        isBond: this.inputData.IsBond ? 1 : 0,
        bondType: this.inputData.BondType,
        isLiftgatePickup: this.inputData.IsLiftgatePickup ? 1 : 0,
        isLiftgateDelivery: this.inputData.IsLiftgateDelivery ? 1 : 0,
        cargoTypeIds: this.inputData.GoodsType
      }
      CreateFBAOrder(param).then(res => {
        if (res.code === 200) {
          var orderNo = res.data
          this.$router.push({
            path: '/order/fba',
            query: {
              orderNo: orderNo
            }
          })
        }
      })
    },
    createExpOrder(item) {
      var param = {
        isDraft: true,
        startCityId: this.inputData.OriginCityId,
        destCityId: this.inputData.DestinationCityId,
        destCountryId: this.inputData.DestinationCountryId,
        quantity: this.inputData.TotalQuantity,
        weight: this.inputData.TotalWeight,
        volume: this.inputData.TotalVolume,
        channelId: item.channelId,
        cargoValue: this.inputData.GoodsValue,
        feeList: item.feeList,
        orderAmount: item.totalAmount,
        buyInsurance: this.inputData.IsInsurance ? 1 : 0,
        productName: this.inputData.GoodsName,
        goodsReadyType: this.inputData.GoodsReadyType,
        goodsReadyTime: this.inputData.GoodsReadyTime,
        isKnowerShipper: this.inputData.IsKnown ? 1 : 0,
        isLiftgatePickup: this.inputData.IsLiftgatePickup ? 1 : 0,
        totalValue: this.inputData.GoodsValue,
        destZipCode: this.inputData.DestinationZipCode,
        cargoTypeIds: this.inputData.GoodsType
      }
      CreateExpOrder(param).then(res => {
        if (res.code === 200) {
          var orderNo = res.data
          this.$router.push({
            path: '/order/exp',
            query: {
              orderNo: orderNo
            }
          })
        }
      })
    },
    createAirOrder(item) {
      var priceInfo = item.feeList.find(item => item.name === 'AIR FREIGHT')
      var param = {
        airChannelId: item.channelId,
        airCompanyCode3: item.airCompanyCode3,
        destAirPortCode3: item.destPortCode,
        startAirPortCode3: item.startPortCode,
        weight: item.totalWeight,
        volume: item.totalVolume,
        quantity: item.totalQuantity,
        validTerm: item.workDays,
        airCompanyId: item.airCompanyId,
        airArrivalType: item.airArrivalType,
        orderServiceType: item.calculationType,
        planDeliveryTime: item.goodsReadTime,
        queryValidTime: item.expirationTime,
        orderTrafficAmount: priceInfo.amount,
        orderAmount: item.totalAmount,
        chargeWeight: priceInfo.units,
        costUnitPrice: priceInfo.unitPrice,
        goodsReadyType: this.inputData.GoodsReadyType,
        isKnowerShipper: this.inputData.IsKnown ? 1 : 0,
        buyInsurance: this.inputData.IsInsurance ? 1 : 0,
        goodsValue: this.inputData.GoodsValue,
        isCustomsBrokerage: this.inputData.IsCustomsBrokerage ? 1 : 0,
        isBond: this.inputData.IsBond ? 1 : 0,
        bondType: this.inputData.BondType,
        isLiftgatePickup: this.inputData.IsLiftgatePickup ? 1 : 0,
        isLiftgateDelivery: this.inputData.IsLiftgateDelivery ? 1 : 0,
        bondAmount: item.bondAmount,
        destLiftgateAmount: item.destLiftgateAmount,
        startLiftgateAmount: item.startLiftgateAmount,
        feeList: [...item.feeList.filter(item => item.name !== 'AIR FREIGHT'), ...item.destFeeList, ...item
          .customsFeeList, ...item.originFeeList
        ],
        startCityId: item.originCityId,
        destCityId: item.destCityId,
        destCountryId: item.destinationCountryId,
        destSvcId: item.destSvcId,
        pickupAmount: item.pickupAmount,
        cargoIDs: this.inputData.GoodsType.join(',')
      }
      var deliveryInfo = item.destFeeList.find(x => x.name == 'AIR DELIVERY FREIGHT')
      if (deliveryInfo != undefined) {
        param.deliveryAmount = deliveryInfo.amount
      }
      CreateAirOrder(param).then(res => {
        if (res.code === 200) {
          var orderNo = res.data
          this.$router.push({
            path: '/order/air',
            query: {
              orderNo: orderNo
            }
          })
        }
      })
    },
    createSeaOrder(item) {
      var priceInfo = item.feeList.find(item => item.name === 'SEA FREIGHT')
      var param = {
        shipPortCode: item.startPortCode,
        destPortCode: item.destPortCode,
        channelId: item.channelId,
        quantity: item.totalQuantity,
        weight: item.totalWeight,
        volume: item.totalVolume,
        orderAmount: item.amount,
        orderServiceType: item.calculationType,
        planDeliveryTime: item.goodsReadTime,
        charge: priceInfo.units,
        unitPrice: priceInfo.unitPrice,
        costAmount: priceInfo.amount,
        totalAmount: item.totalAmount,
        workDays: item.workDays,
        goodsReadyType: this.inputData.GoodsReadyType,
        isKnowerShipper: this.inputData.IsKnown ? 1 : 0,
        buyInsurance: this.inputData.IsInsurance ? 1 : 0,
        priceEndDate: item.expirationTime,
        shipCompanyCode: item.modeCodes,
        goodsValue: this.inputData.GoodsValue,
        isCustomsBrokerage: this.inputData.IsCustomsBrokerage ? 1 : 0,
        isBond: this.inputData.IsBond ? 1 : 0,
        bondType: this.inputData.BondType,
        isLiftgatePickup: this.inputData.IsLiftgatePickup ? 1 : 0,
        isLiftgateDelivery: this.inputData.IsLiftgateDelivery ? 1 : 0,
        bondAmount: item.bondAmount,
        destLiftgateAmount: item.destLiftgateAmount,
        startLiftgateAmount: item.startLiftgateAmount,
        startCityId: item.originCityId,
        destCityId: item.destCityId,
        destCountryId: item.destinationCountryId,
        feeList: [...item.feeList.filter(item => item.name !== 'SEA FREIGHT'), ...item.destFeeList, ...item
          .customsFeeList, ...item.originFeeList
        ],
        destSvcId: item.destSvcId,
        pickupAmount: item.pickupAmount
      }
      var deliveryInfo = item.destFeeList.find(x => x.name == 'SEA DELIVERY FREIGHT')
      if (deliveryInfo != undefined) {
        param.deliveryAmount = deliveryInfo.amount
      }
      CreateSeaOrder(param).then(res => {
        if (res.code === 200) {
          var orderNo = res.data
          this.$router.push({
            path: '/order/sea',
            query: {
              orderNo: orderNo
            }
          })
        }
      })
    },
    filteredDestFeeList(item) {
      return item.destFeeList.filter(fee => fee.name != 'AIR DELIVERY FREIGHT')
    },
    usedDestFeeList(item) {
      return item.destFeeList.filter(fee => fee.name == 'AIR DELIVERY FREIGHT')
    },
    destFeeSum(item) {
      var list = this.filteredDestFeeList(item)
      if (list) {
        return list.reduce((accumulator, item) => accumulator + item.amount, 0).toFixed(3)
      } else {
        return 0
      }
    },
    destFeeUesdSum(item) {
      var list = this.usedDestFeeList(item)
      if (list) {
        return (list.reduce((accumulator, item) => accumulator + item.amount, 0) + parseFloat(item
          .destLiftgateAmount)).toFixed(3)
      } else {
        return 0
      }
    },
    customsFeeSum(item) {
      var customsFee = 0
      if (item.customsFeeList) {
        customsFee = parseFloat(item.customsFeeList.reduce((accumulator, customsFee) => accumulator +
          customsFee.amount, 0))
      }
      return (parseFloat(item.ISFBondAmount) + parseFloat(item.bondAmount) + customsFee).toFixed(3)
    },
    originFeeSum(item) {
      if (item.originFeeList) {
        return item.originFeeList.reduce((accumulator, customsFee) => accumulator + customsFee.amount, 0)
          .toFixed(3)
      } else {
        return 0
      }
    },
    pickupFeeSum(item) {
      return (parseFloat(item.startLiftgateAmount) + parseFloat(item.pickupAmount)).toFixed(3)
    }

  }
}
</script>
<style scoped lang='scss'>
.resultList {
  margin-top: 16px;

  .list-main {
    padding: 0;

    li {
      width: 895px;
      //height: 160px;
      background: #FFFFFF;
      border-radius: 8px;
      border: 1px solid rgba(233, 85, 6, 0);
      margin: 8px 0;
      overflow: hidden;
      cursor: pointer;

      .list-item {
        width: 895px;
        height: 160px;
        background: #FFFFFF;
        border-radius: 8px;
        border: 1px solid rgba(233, 85, 6, 0);
        display: flex;

        .list-left {
          width: 70%;
          text-align: left;
          margin: 16px;
          border-right: 1px solid #DDDDDD;

          .div-tag {
            display: flex;

            .list-tag {
              width: 88px;
              height: 25px;
              background: rgba(2, 127, 252, 0.08);
              border-radius: 13px;
              font-size: 13px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              color: #027FFC;
              text-align: center;
              line-height: 25px;
              margin-left: 5px;
              display: inline-block;
            }
          }

          div:nth-of-type(2),
          div:nth-of-type(3) {
            height: 32px;
            display: flex;
            align-items: center;
            font-size: 14px;
            font-family: D, D;
            font-weight: normal;
            color: #333333;
          }

          button {
            width: 100px;
            height: 32px;
            background: rgba(233, 85, 6, 0);
            border-radius: 8px;
            border: 1px solid rgba(233, 85, 6, 0.24);
            font-size: 14px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            color: #E95506;
          }

          .p-line {
            width: 16px;
            height: 1px;
            background: #AAAAAA;
            display: block;
            margin: 0 8px;
          }

          .p-plus {
            color: #AAAAAA;
            display: block;
            margin: 0 8px;
          }
        }

        .list-middle {
          width: 20%;
          margin: 18px 16px;
          text-align: center;

          div:nth-of-type(1) {
            font-size: 18px;
            font-family: D-DINExp, D-DINExp;
            font-weight: bold;
            color: #333333;
            height: 32px;
          }

          button {
            width: 108px;
            height: 32px;
            background: #E95506;
            border-radius: 8px;
            border: 1px solid #E95506;
            font-size: 16px;
            font-family: D-DINExp, D-DINExp;
            font-weight: bold;
            color: #FFFFFF;
            cursor: pointer;
          }

          div:nth-of-type(2) {
            font-size: 13px;
            font-family: D, D;
            font-weight: normal;
            margin: 10px 0;

            span:nth-of-type(1) {
              color: #AAAAAA;
              margin-right: 8px;
            }

            span:nth-of-type(2) {
              color: #333333;
            }
          }

          div:nth-of-type(3) {
            font-size: 13px;
            font-family: D, D;
            font-weight: normal;
            color: #333333;
          }
        }

        .list-right {
          width: 10%;
          font-size: 12px;
          margin: 16px;
          width: 24px;
          height: 128px;
          background: rgba(233, 85, 6, 0.06);
          border-radius: 4px;
          color: #E95506;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      .list-card {
        .card-title {
          width: 895px;
          height: 40px;
          background: rgba(170, 170, 170, 0.08);
          font-size: 14px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 40px;
          text-align: left;
          padding-left: 16px;
        }

        .card-table {
          table {
            width: 895px;
            border-collapse: collapse;
            text-align: left;
            padding: 0 8px;

            tr:nth-of-type(1) {
              td {
                font-size: 13px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 550;
                color: #333333;
              }
            }

            tr {
              height: 40px;

              td {
                border-bottom: 1px solid rgba(170, 170, 170, 0.24);
                font-size: 13px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                color: #333333;
                padding: 0 16px;
              }

              td:last-child {
                text-align: right;
              }
            }
          }
        }

        .card-subtotal {
          font-size: 14px;
          font-family: D-DINExp, D-DINExp;
          font-weight: bold;
          color: #333333;
          height: 40px;
          line-height: 40px;
          text-align: right;
          padding-right: 16px;
        }

        .card-total {
          height: 40px;
          line-height: 40px;
          text-align: right;
          background: rgba(2, 127, 252, 0.08);
          font-size: 16px;
          font-family: D-DINExp, D-DINExp;
          font-weight: bold;
          color: #333333;
          padding-right: 16px;
        }

        .card-remarks {
          width: 863px;
          height: 161px;
          background: rgba(0, 0, 0, 0.02);
          border-radius: 8px;
          margin: 16px;
          text-align: left;
          overflow-y: scroll;

          p {
            padding: 4px 8px;
            margin: 0;
          }

          span {
            padding: 0 8px;
            display: block;
          }
        }
      }
    }

  }
}
</style>
